import { Content } from 'src/contexts/ContentContext';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { ShieldCheckSolidIcon } from 'src/svgs/ShieldCheckSolidIcon';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './CampaignModal.css';

export const CampaignModalFooter = () => {
  return (
    <Stack
      className={styles.sellOutProtectionBox}
      alignItems="center"
      gap="m"
      width="full"
    >
      <span style={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>
        <ShieldCheckSolidIcon size={vars.iconSize.xl} />
      </span>
      <span style={{ flex: 1 }}>
        <Content id={ContentId.CampaignSellOutProtectionInfo} />
      </span>
    </Stack>
  );
};
